import { ServerResponse } from './server.tokens';

/**
 * In SSR environment, disable caching by setting `routeCache.disabled` on response.locals
 * @param response
 */
export function disableSsrCaching(response: ServerResponse): void {
  response.locals.rawEnv.server.routeCache.disabled = true;
}
